import GetPWT from "components/shared/GetPWT/GetPWT";

if (window.delayThirdPartyScript) {
  document.addEventListener('DOMContentLoaded', function() {
    GetPWT.getPWTAndGPT();
  })
} else {
  GetPWT.getPWTAndGPT();
}